import { render, staticRenderFns } from "./ButtonFunctionalitiesWinEdit.vue?vue&type=template&id=58c04bf0&scoped=true&"
import script from "./ButtonFunctionalitiesWinEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonFunctionalitiesWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFunctionalitiesWinEdit.vue?vue&type=style&index=0&id=58c04bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c04bf0",
  null
  
)

export default component.exports